import React from "react";
import AsideBase from "./AsideBase";
import {Image, ListGroup} from "react-bootstrap";

import '../../../assets/sass/global/asides/other-players.scss';
import ShadowScrollbars from "../custom_scrollbars/ShadowScrollbars";

import dustinWilliamsonAvatar from "../../../assets/img/demo/dustin-williamson-avatar.png";
import darrellMckinneyAvatar from "../../../assets/img/demo/darrell-mckinney-avatar.png";
import eduardoMilesAvatar from "../../../assets/img/demo/eduardo-miles-avatar.png";
import brandonPenaAvatar from "../../../assets/img/demo/brandon-pena-avatar.png";
import jacobHawkinsAvatar from "../../../assets/img/demo/jacob-hawkins-avatar.png";

const players = [
    {avatar: dustinWilliamsonAvatar},
    {avatar: darrellMckinneyAvatar},
    {avatar: eduardoMilesAvatar},
    {avatar: jacobHawkinsAvatar},
    {avatar: brandonPenaAvatar},
    {avatar: dustinWilliamsonAvatar},
    {avatar: eduardoMilesAvatar},
    {avatar: darrellMckinneyAvatar},
    {avatar: brandonPenaAvatar},
    {avatar: jacobHawkinsAvatar},
    {avatar: dustinWilliamsonAvatar},
    {avatar: darrellMckinneyAvatar},
    {avatar: eduardoMilesAvatar},
    {avatar: jacobHawkinsAvatar},
    {avatar: brandonPenaAvatar},
    {avatar: dustinWilliamsonAvatar},
    {avatar: eduardoMilesAvatar},
    {avatar: darrellMckinneyAvatar},
    {avatar: brandonPenaAvatar},
    {avatar: jacobHawkinsAvatar},
];

class OtherPlayers extends AsideBase {
    /**
     * Renders the header of the aside component.
     * @returns {React.ReactNode} The aside header.
     */
    renderHeader = () => {
        const {title} = this.props;
        return (
            <div className="title"> {title} </div>
        );
    };

    /**
     * Renders the body of the aside component.
     * @returns {React.ReactNode} The aside body.
     */
    renderBody = () => {
        return this.wrapWithinScrollbar(this.renderPlayers());
    };

    /**
     * Wraps the content within scrollbar.
     * @param content {React.ReactNode} The content witch renders within scrollbar.
     * @returns {React.ReactNode} The wrapped component.
     */
    wrapWithinScrollbar = (content) => {
        return (<ShadowScrollbars> {content} </ShadowScrollbars>)
        // return content;
    };

    /**
     * Renders avatars of players.
     * @returns {React.ReactNode} The players avatars.
     */
    renderPlayers = () => {
        // const {players} = this.props;
        // const players = players;
        // TODO: Fetch players form props or API.

        return (
            <ListGroup variant={null}> {
                players.map((player, index) => <ListGroup.Item key={index}> <Image className="avatar" src={player.avatar} roundedCircle onClick={this.handlePlayerClick}/> </ListGroup.Item>)}
            </ListGroup>
        )
    };


    handlePlayerClick = (event) => {

    };


    asideClasses = () => 'other-players';

    static defaultProps = {
        title: 'Other Players'
    };
}

export default OtherPlayers
